import Vue from 'vue';

// 使用 Event Bus
const color3 = new Vue();

export default color3;



// WEBPACK FOOTER //
// ./src/view/framework/home/color2.js